import React from 'react';
import { useTranslation } from 'react-i18next';

interface NavigationProps {
  mobile?: boolean;
}

const Navigation: React.FC<NavigationProps> = ({ mobile = false }) => {
  const { t } = useTranslation();
  const navItems = [
    { href: '#features', label: t('landing.header.navigation.features') },
    { href: '#how-it-works', label: t('landing.header.navigation.how_it_works') },
    { href: '#pricing', label: t('landing.header.navigation.pricing') },
    { href: '#testimonials', label: t('landing.header.navigation.testimonials') },
    { href: '#mobile-app', label: t('landing.header.navigation.download') },
    { href: '#faq', label: t('landing.header.navigation.faq') }
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (mobile) {
    return (
      <nav className="space-y-2">
        {navItems.map((item) => (
          <a
            key={item.href}
            href={item.href}
            onClick={item.href.startsWith('#') ? (e) => handleClick(e, item.href) : undefined}
            className="block px-4 py-2 text-white hover:text-indigo-300 hover:bg-slate-800/50 rounded-lg transition-colors"
          >
            {item.label}
          </a>
        ))}
      </nav>
    );
  }

  return (
    <nav className="flex items-center space-x-8">
      {navItems.map((item) => (
        <a
          key={item.href}
          href={item.href}
          onClick={item.href.startsWith('#') ? (e) => handleClick(e, item.href) : undefined}
          className="text-white hover:text-indigo-300 font-normal transition-colors relative group"
        >
          {item.label}
          <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 transition-all duration-300 group-hover:w-full"></span>
        </a>
      ))}
    </nav>
  );
};

export default Navigation;